export default {
    modalShowImageVariations: {
        imageAi: "IA d'image",
        regenerateImage: 'Générer du nouveau contenu',
        description: 'Description',
        style: 'Style',
        saveToLibrary: 'Enregistrer dans la bibliothèque',
        continue: 'Continuer',
        cancel: 'Annuler',
        select: 'Sélectionner',
        copy: 'Copier',
        selectedImage: 'Image sélectionnée',
        saved: 'Sauvé',
        variations: 'Variations',
    },
};
